import { memo, useRef, useState } from 'react';
import { Container } from '@mui/material';
import bankStyles from '../../assets/css/banks.module.css';
import BankFilters from './BankFilters';
import PaginatedBanks from './PaginatedBanks';
import BankSelectionTitle from './BankSelectionTitle';
import { Bank, BankCountry } from '../../services/interfaces/bank.interface';

interface BankSelectionProps {
	onBankSelect(bank: Bank): void;
	onCountryChange(country: BankCountry): void;
}

const BankSelection = ({ onBankSelect, onCountryChange }: BankSelectionProps) => {
	const [country, setCountry] = useState<BankCountry>('AT');
	const [searchFilter, setSearchFilter] = useState<string>('');
	const searchRef = useRef(null);

	const changeCountry = (country: BankCountry) => {
		onCountryChange(country);
		setCountry(country);
	};

	return (
		<Container
			id="bank-selection-container"
			className={bankStyles['bank-selection-container']}
			style={{ width: '100%', color: 'rgb(14,14,14,95%)' }}
		>
			<div className={bankStyles['element-container']}>
				<BankSelectionTitle />
			</div>
			<div className={bankStyles['element-container']} style={{ paddingBottom: '0' }}>
				<BankFilters
					country={country}
					onSearchFilterChange={setSearchFilter}
					onCountryChange={changeCountry}
					searchRef={searchRef}
				/>
			</div>
			<div className={bankStyles['element-container']}>
				<PaginatedBanks
					country={country}
					searchFilter={searchFilter}
					searchRef={searchRef}
					onBankSelect={onBankSelect}
				/>
			</div>
		</Container>
	);
};

export default memo(BankSelection);
